import http from "../http";
const { post } = http;

export default {
  login(data, config) {
    return post(`/cmoapi/api/login`, data, config);
  },
  logout(data, config) {
    return post(`/cmoapi/api/logout`, data, config);
  },
  logCode(data, config) {
    return post(`/cmoapi/api/get_captcha`, data, config);
  },
};
